import { render } from "./Footer.vue?vue&type=template&id=e782f64c&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=e782f64c&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e782f64c"]])

export default __exports__